import types from './types';

const setPageNumber = (pageNumber: number) => {
  return { type: types.PAGE_NUMBER, payload: pageNumber };
};

const setTotalPages = (totalPages: number) => {
  return { type: types.TOTAL_PAGES, payload: totalPages };
};

const setTotalElements = (totalElements: number) => {
  return { type: types.TOTAL_ELEMENTS, payload: totalElements };
};

const setPageSize = (pageSize: number) => {
  return { type: types.PAGE_SIZE, payload: pageSize };
};

export default {
  setPageNumber,
  setTotalPages,
  setTotalElements,
  setPageSize
};
